import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';

import { Features } from 'APP/packages/features/Features';
import Entities from 'STORE';
import { Group } from 'STORE/Groups/Group';
import { getVisibleGroups } from 'UTILS/getVisibleGroups';

export interface IGroupListPresenterParams {
  groups: Group[];
}

interface IGroupListPresenter {
  groups: Group[];
  isSpacesLoading: boolean;
  isShowPlaceholder: boolean;
  isShowGroupsList: boolean;
  visibleGroups: Group[];
  groupHash: string;
  setGroups(groups: Group[]): void;
}

export const useGroupListPresenter = (data: IGroupListPresenterParams): IGroupListPresenter => {
  const { groups } = data;

  const presenter = useLocalObservable<IGroupListPresenter>(() => ({
    groups,

    get isSpacesLoading(): boolean {
      return Features.isSpacesEnabled() && Entities.spacesStore.isLoading;
    },

    get isShowPlaceholder(): boolean {
      return Entities.GroupsStore.isLoading || presenter.isSpacesLoading;
    },

    get isShowGroupsList(): boolean {
      return presenter.isShowPlaceholder || presenter.visibleGroups.length > 0;
    },

    get visibleGroups(): Group[] {
      return getVisibleGroups(presenter.groups);
    },

    // TODO: this getter should be removed, after initGroups method refactored
    // This method triggers list to redrawn a huge number of times
    get groupHash(): string {
      if (Entities.GroupsStore.isLoading) {
        return presenter.visibleGroups.length.toString();
      }

      return presenter.visibleGroups.reduce((result, group) => {
        result += '_' + group.id;
        return result;
      }, '');
    },

    setGroups(groups: Group[]): void {
      presenter.groups = groups;
    },
  }));

  useEffect(() => {
    presenter.setGroups(groups);
  }, [groups]);

  return presenter;
};
